import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MatButton} from "@angular/material/button";

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StringUtils} from "../../utils/string-utils";
import {PerformanceDefaultsComponent} from "../../project-defaults/performance-defaults/performance-defaults.component";
import {PerformanceDefaultsService} from "../../services/performance-defaults.service";
import {EntityPerformanceDefaults} from "../../model/entity-performance-defaults";
import {PerformanceDefaults} from "../../model/performance-defaults";

@Component({
  selector: 'app-entity-performance-defaults-dialog',
  imports: [
    MatButton,
    PerformanceDefaultsComponent
],
  templateUrl: './entity-performance-defaults-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './entity-performance-defaults-dialog.component.css'
})
export class EntityPerformanceDefaultsDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<EntityPerformanceDefaultsDialogComponent>>(MatDialogRef);
  private readonly defaultsService = inject(PerformanceDefaultsService);
  private readonly data = inject(MAT_DIALOG_DATA);


  readonly entityId: string;
  readonly revision: number;
  readonly entityPerformanceDefaults = signal<EntityPerformanceDefaults>(undefined!);
  readonly errorMessage = signal<string>(undefined!);
  readonly isBusy = signal<boolean>(undefined!);

  constructor() {
    this.entityId = this.data.entityId;
    this.revision = this.data.revision;
  }

  ngOnInit(): void {
    this.isBusy.set(true);
    this.defaultsService.getDefaultValues(this.entityId, this.revision).subscribe({
      next: (defaults: PerformanceDefaults) => {
        this.entityPerformanceDefaults.set(new EntityPerformanceDefaults());
        this.entityPerformanceDefaults().entityId = this.entityId;
        this.entityPerformanceDefaults().entityRevision = this.revision;
        this.entityPerformanceDefaults().performanceDefaults = defaults;
        this.isBusy.set(false);
      }, error: (error: any) => this.handleError(error)
    });
  }

  performanceDefaultUpdated(defaults: PerformanceDefaults): void {
    this.entityPerformanceDefaults().performanceDefaults = defaults;
  }

  save(): void {
    this.isBusy.set(true);
    this.defaultsService.saveEntityDefaults(this.entityPerformanceDefaults()).subscribe({
      next: (updated: EntityPerformanceDefaults) => {
        this.entityPerformanceDefaults.set(updated);
        this.isBusy.set(false);
        this.dialogRef.close();
      }, error: (error: any) => this.handleError(error)
    });
  }

  handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  close(): void {
    this.dialogRef.close();
  }

}
